module.exports = __webpack_public_path__ + "media/images/number-one-icon-85911f01cd5e3e3e3288d4549e2394d8.png";